<template>
  <Form @submit="submit"
        :validation-schema="schema">
    <section class="application-create__form">
      <div class="container-xxxl">
        <div class="row">
          <div class="col-xxl-6 offset-xxl-3">
            <h3 class="application__form__title">{{ $lang.app.APPLICATION }}</h3>
            <div class="application__form__block">
              <div class="input__group input__checkbox">
                <Field type="checkbox" name="personalDataAgreement"
                       id="personal-data-agreement-input"
                       class="checkbox"
                       :value="true"/>
                <div class="flex items-center">
                  <label for="personal-data-agreement-input" class="label">{{ $lang.app.PERSONAL_DATA_AGREEMENT }}</label>
                  <a class="ml-2" @click="$emitter.emit('open-personal-data-agreement-modal')">({{ $lang.app.PREVIEW }})</a>
                </div>
              </div>
              <ErrorMessage name="personalDataAgreement" class="text-xs text-red-400"/>
              <div class="input__group input__checkbox mb0">
                <Field type="checkbox" name="personalDataAuthenticity"
                       id="personal-data-authenticity-input"
                       class="checkbox"
                       :value="true"/>
                <label for="additional__expertise" class="label">{{ $lang.app.PERSONAL_DATA_AUTHENTICITY }}</label>
              </div>
              <ErrorMessage name="personalDataAuthenticity" class="text-xs text-red-400"/>
            </div>
          </div>
        </div>
      </div>
    </section>
    <PersonalDataAgreementModal/>
    <GenerateApplicationFileModal/>

    <div class="application-create__controls">
      <div class="container-fluid">
        <div class="application-create__controls__wrapper">
          <button type="button" @click="$router.go(-1)" class="button button--cancel">{{ $lang.app.CANCEL }}</button>
          <button type="submit" class="button">{{ $lang.app.GENERATE_APPLICATION_AND_SIGN }}</button>
        </div>
      </div>
    </div>
  </Form>
</template>

<script>
import {Field, Form, ErrorMessage} from 'vee-validate';
import PersonalDataAgreementModal from "../../../../components/modal/PersonalDataAgreementModal";
import * as yup from "yup";
import GenerateApplicationFileModal
  from "../../../../components/applicant/application/modals/GenerateApplicationFileModal";

export default {
  name: "ApplicantApplicationAppFileCreate",
  components: {
    Form, Field, ErrorMessage,
    PersonalDataAgreementModal,
    GenerateApplicationFileModal,
  },
  data() {
    return {
      schema: yup.object({
        personalDataAgreement: yup.mixed().required(),
        personalDataAuthenticity: yup.mixed().required()
      })
    }
  },
  methods: {
    submit() {
      this.$emitter.emit('openGenerateApplicationFileModal', this.$route.params.applicationId)
    },
  },
};
</script>
